(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 5620:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(4872);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var pages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5075);

var Page = pages__WEBPACK_IMPORTED_MODULE_0__["default"];
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_cms_MapPageContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1612);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6270);




var CMSPage = function(param) {
    var cmsData = param.cmsData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: cmsData.pageTitle,
        url: cmsData.pageCanonicalUrl,
        description: cmsData.pageDescription,
        imageCTA: cmsData.metaImageCta,
        shouldBeIndexed: cmsData.shouldBeIndexed,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cms_MapPageContent__WEBPACK_IMPORTED_MODULE_2__/* .MapPageContent */ .N, {
            pageContent: cmsData.pageContentCollection.items
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CMSPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,751,890,774,888,179], function() { return __webpack_exec__(5620); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);